import { useQuery } from '@tanstack/react-query';
import { QueryConfig, ExtractFnReturnType } from '../../../../lib/react-query';
import i18n from '../../../../i18n';
import { getServiceIndicatorSelect } from '../api/serviceIndicators';




type QueryFnType = typeof getServiceIndicatorSelect;

type UseServiceIndicatorSelectOptions = { 
  config?: QueryConfig<QueryFnType>;
};

export const useServiceIndicatorSelect = ({ config = {} }: UseServiceIndicatorSelectOptions) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['serviceIndicatorsSelect', i18n.language],
        queryFn: () => getServiceIndicatorSelect(), //
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });
};